<template>
  <div>
    <h3 class="mb-5">Video Rotate</h3>
    <div class="h4 mb-5">至少3個，可新增多個</div>

    <!-- itemList -->
    <PageCollapse v-for="(item, i) in bu.video_rotate" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Video {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- banner type = Video -->
        <div>
          <!-- upload type -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <h4 class="w-180px mr-35px">UploadType</h4>
            <div class="flex-grow-1">
              <v-radio-group v-model="item.upload_type" row>
                <div
                  v-for="uploadType in [
                    {
                      label: '自電腦上傳影片',
                      value: 'file',
                    },
                    {
                      label: '來自Youtube/Youku連結',
                      value: 'link',
                    },
                  ]"
                  :key="uploadType.value"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="uploadType.value">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ uploadType.label }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
        </div>

        <!-- banner type = Video, upload type = 自電腦上傳影片 -->
        <div v-if="item.upload_type == 'file'">
          <!-- 影片上傳 -->
          <div class="form-item d-flex px-5 pt-5 pb-5">
            <div class="w-200px">
              <h4 class="mb-10px">影片</h4>
              <div class="h5 ink-02-medium--text">
                影片支援格式：.mp4, .mov, .avi <br />
                檔案大小限制：&lt; 10 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <FileUploader
                v-model="item.url"
                dir="bu_videos"></FileUploader>
            </div>
          </div>
        </div>

        <!-- banner type = Video, upload type = 來自Youtube/Youku連結 -->
        <div v-if="item.upload_type == 'link'">
          <!-- Youtube -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">影片連結</h4>
            <div class="flex-grow-1 my-3">
              <v-text-field
                v-model="item.url"
                prepend-inner-icon="mdi-link"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Youku -->
          <!--<label class="form-item px-5 d-flex">-->
            <!--<h4 class="w-180px my-5 mr-6">Youku</h4>-->
            <!--<div class="flex-grow-1 my-3">-->
              <!--<div class="form-input-group">-->
                <!--<div class="prepend-icon" style="top: 45%;">-->
                  <!--<v-icon>link</v-icon>-->
                <!--</div>-->
                <!--<input type="text" class="pl-42px" v-model="item.youkuUrl" />-->
              <!--</div>-->
            <!--</div>-->
          <!--</label>-->
        </div>

        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Preview Image</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.preview_image"
              dir="bu_videos"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加VideoRotate</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    bu: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    FileUploader,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        // video
        upload_type: 'file',
        // video from computer
        video: '',
        // video from link
        url: '',
        // basic
        preview_image: '',
      };
      this.bu.video_rotate.push(template);
    },
    deleteItem(item) {
      const index = this.bu.video_rotate.map((option) => option.id).indexOf(item.id);
      this.bu.video_rotate.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.bu.video_rotate.length - 1) {
        this.bu.video_rotate.splice(i, 1);
        this.bu.video_rotate.unshift(item);
        return;
      }
      // item become next index
      this.bu.video_rotate.splice(i, 1);
      this.bu.video_rotate.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.bu.video_rotate.splice(i, 1);
        this.bu.video_rotate.push(item);
        return;
      }
      // item become previous index
      this.bu.video_rotate.splice(i, 1);
      this.bu.video_rotate.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
